module.exports = __webpack_public_path__ + "img/radio-memory-logo.d7e3873b.png";